import React from "react"
import { Controller, useFormState } from "react-hook-form"

const CustomTextField = ({ name, label, Component, rules, helperText, type, req, rows = 1, readOnly = false, endAdornment, startAdornment, ...restProps }) => {
  const formState = useFormState()

  return (
    <Controller
      name={name}
      render={({ field: { onChange, onBlur, value, ref } }) => (
        <Component
          margin="normal"
          type={type}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          rows={rows}
          ref={ref}
          error={Boolean(formState.errors && formState.errors[name])}
          // color="secondary"
          helperText={formState.errors[name]?.message || helperText}
          label={label}
          variant="outlined"
          fullWidth
          required={req}
          multiline={restProps.multiline}
          {...restProps}
          InputProps={{
            readOnly: readOnly,
            startAdornment: startAdornment,
            endAdornment: endAdornment,
          }}
        />
      )}
      rules={rules}
    />
  )
}

export default CustomTextField
